import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import activestatus from "../assets/images/activeStatus.svg";
import blackDot from "../assets/images/blackDot.svg";
import blog from "../assets/images/blogprofile.svg";
import caller from "../assets/images/caller.svg";
import crossarrow from "../assets/images/crossarrow.svg";
import documentation from "../assets/images/documentation.svg";
import profilepic from "../assets/images/dummy-profile-pic.jpg";
import fb from "../assets/images/fb.svg";
import instagram from "../assets/images/instaprofile.svg";
import linkedin from "../assets/images/linkedin.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import profileicon from "../assets/images/profileicon.svg";
import sales from "../assets/images/sales.svg";
import sqtbg from "../assets/images/sqtbg.png";
import { default as star, default as stars } from "../assets/images/stars.svg";
import twitter from "../assets/images/twitterprofile.svg";
import { commonservices, CountCharacter } from "../services/CommonServices";
import { GetMachinePortfolioList } from "../services/ReduxTookit/Slice/MachineRedux";
import { GetSubscriberProfile } from "../services/ReduxTookit/Slice/SubscribersRedux";
import BreadcrumbsNav from "./common-component/BreadcrumbsNav";
import Loader, { LoaderType } from "./common-component/Loader";
import Nodata from "./common-component/Nodata";
import { renderRatingStars } from "./Marketplace";

function MarketPlaceDeveloper() {
  const location = useLocation();
  let navigate = useNavigate();
  const { subscriberId } = location.state || {};

  let dispatch = useDispatch();
  let Userdata = useSelector((state) => state.userinfo.UserInfo);
  const [likeItem, setLikeItem] = useState(true);
  const [TabState, setTabState] = useState("Profile");
  const [DeveloperDetailLoading, setDeveloperDetailLoading] = useState(false);
  const [DeveloperDetail, setDeveloperDetail] = useState("");

  const [MachineLoader, setMachineLoader] = useState(false);
  const [MachineDetailLoader, setMachineDetailLoader] = useState(false);
  const [MachineList, setMachineList] = useState([]);

  const [page, setPage] = useState(1); // for number of page in data
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [totalRecord, setTotalRecord] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
  });
  const BreadcrumbSingle = [
    {
      name: "Marketplace",
      link: "/marketplace",
      active: false,
    },
    {
      name: "Developer",
      active: true,
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 92) {
        document.body.classList.add("scrolled");
        document.body.classList.add("sticky-panel");
      } else {
        document.body.classList.remove("scrolled");
        document.body.classList.remove("sticky-panel");
      }
    };

    // Ensure classes are reset on mount
    document.body.classList.remove("scrolled", "sticky-panel");

    // Check the current scroll position when component mounts
    handleScroll();

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      // Remove the classes when component unmounts
      document.body.classList.remove("scrolled", "sticky-panel");
    };
  }, []); // Empty dependency array ensures this effect runs once

  // const GetUserData = useSelector(
  //   (state) => state?.userredux?.GetByPrimarykeyData?.data
  // );
  // let DeveloperDetail = null;
  // if (GetUserData?.isValidate) {
  //   DeveloperDetail = GetUserData?.data?.data;
  // }

  async function getDeveloperDetail() {
    setDeveloperDetailLoading(true);
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.PROFILE_DETAIL,
    //     body: {},
    //   },
    //   false
    // );
    // let response = apiResponse(false, resData, setDeveloperDetailLoading);
    // if (response?.isValidate) {
    //   setDeveloperDetail(response?.data?.data);
    // }
    // if (!response?.isValidate) {
    // }

    try {
      dispatch(GetSubscriberProfile({ id: subscriberId })).then((response) => {
        if (response?.payload?.isValidate) {
          setDeveloperDetail(response?.payload?.data?.data?.dataList1[0]);
          setDeveloperDetailLoading(false);
        }
        if (!response?.payload?.isValidate) {
          setDeveloperDetailLoading(false);
          setDeveloperDetail([]);
        }
      });
    } catch (error) {
      setDeveloperDetailLoading(false);
    }
  }

  async function getMachineList() {
    if (filter?.page === 1) {
      setMachineLoader(true);
    } else {
      setLoading(true);
      loadingRef.current = true;
    }
    let body = {
      subscriberid: subscriberId ? parseInt(subscriberId) : "",
      pagenumber: filter?.page,
      pagesize: process.env.REACT_APP_MACHINE_WIDGET_PAGE_SIZE,
    };

    try {
      dispatch(GetMachinePortfolioList(body)).then((response) => {
        if (response?.payload?.isValidate) {
          setMachineList((prevData) => [
            ...prevData,
            ...response?.payload?.data?.data?.dataList1,
          ]);
          setTotalRecord(response?.payload?.data?.recordcount);
          setLoading(false);
          loadingRef.current = false;
        }
        if (!response?.payload?.isValidate) {
          setMachineList([]);
          setLoading(false);
          loadingRef.current = false;
        }
        setLoading(false);
      });
    } catch (error) {}

    // --------- Before Redux
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL?.MACHINE?.GET_MACHINE_PORTFOLIO_LIST,
    //     body: body,
    //   },
    //   true
    // );

    // let response = apiResponse(false, resData, setMachineLoader);
    // if (response?.isValidate) {
    //   // setMachineList(response?.data?.data?.dataList1);
    //   setMachineList((prevData) => [
    //     ...prevData,
    //     ...response?.data?.data?.dataList1,
    //   ]);
    //   setTotalRecord(response?.data?.recordcount);
    // }
    // if (!response?.isValidate) {
    //   setMachineList([]);
    // }
    // setLoading(false);
  }

  useEffect(() => {
    if (subscriberId) {
      getDeveloperDetail();
    }
  }, []);

  useEffect(() => {
    if (subscriberId) {
      getMachineList();
    }
  }, [subscriberId, filter]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const bottomPosition = document.body.scrollHeight - 300;
      if (
        scrollPosition >= bottomPosition &&
        !loading &&
        !loadingRef.current &&
        MachineList?.length < totalRecord &&
        TabState === "Portfolio"
      ) {
        loadingRef.current = true;
        let updatedFilter = { ...filter };
        updatedFilter.page = updatedFilter.page + 1;
        setFilter(updatedFilter);
        // setPage((prevPage) => prevPage + 1);
      }
    };
    const debouncedScroll = debounce(handleScroll, 300);
    window.addEventListener("scroll", debouncedScroll);
    return () => {
      window.removeEventListener("scroll", debouncedScroll);
    };
  });

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
  const handleLikeItem = () => {
    setLikeItem(!likeItem);
  };
  const fnMachineDetail = (machine_id) => {
    navigate(
      `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
        String(machine_id),
      )}/Marketplace`,
    );
  };

  return (
    <div className="dashboard-main market-place-page-main market-place-detail-page-main developer-detail-page">
      <div className="all-page-top">
        <div className="stickypanelnew">
          <Container>
            <div className="d-flex justify-content-between">
              <div className="d-flex stickeyinner">
                <div className="bradnew">
                  <BreadcrumbsNav pageNav={BreadcrumbSingle} />
                </div>
              </div>
              <div className="top-section-right d-flex gap-2 mt-0">
                <div className="top-section-right-inner">
                  <img src={sales} alt="sales" />
                  <span>Sales</span>
                  <h5>
                    {DeveloperDetail?.salescount
                      ? DeveloperDetail?.salescount
                      : "0"}
                  </h5>
                </div>
                <button
                  className="blue-btn"
                  onClick={() => {
                    setTabState("Portfolio");
                  }}
                >
                  View Portfolio
                </button>
              </div>
            </div>
          </Container>
        </div>
        <Container>
          <div className="top-section-all d-block">
            <div className="top-section-left">
              <BreadcrumbsNav pageNav={BreadcrumbSingle} />
              {DeveloperDetailLoading ? (
                <Loader type={LoaderType.DeveloperHeader} count={1} />
              ) : (
                <div className="d-flex align-items-center justify-content-between w-100 mb40">
                  <div className="top-left-sect-detail">
                    <div className="top-left-sect-detail-img">
                      {/* <img src={sqtlogo} alt="sqtlogo" /> */}
                      <img
                        src={
                          DeveloperDetail?.profilepicurl
                            ? DeveloperDetail?.profilepicurl
                            : profilepic
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = profilepic;
                        }}
                      />
                    </div>
                    <div className="top-left-sect-detail-content">
                      <div className="title-rating">
                        <h5>
                          {DeveloperDetail?.companyname
                            ? DeveloperDetail?.companyname
                            : DeveloperDetail?.subscribername}
                        </h5>
                        {DeveloperDetail?.avgrating > 0 && (
                          <div className="rating-main">
                            <img src={star} alt="star" />
                            <p>{DeveloperDetail?.avgrating?.toFixed(1)}</p>
                          </div>
                        )}
                      </div>
                      <p>
                        Member Since{" "}
                        {DeveloperDetail?.createdon
                          ? commonservices.getDateInFormatCustom(
                              DeveloperDetail?.createdon,
                              null,
                              "MMMM YYYY",
                            )
                          : 2024}
                      </p>
                    </div>
                  </div>
                  <div className="top-section-right marketdetail-one">
                    <div className="top-section-right-inner">
                      <img src={sales} alt="sales" />
                      <span>Sales</span>
                      <h5>
                        {DeveloperDetail?.salescount
                          ? DeveloperDetail?.salescount
                          : "0"}
                      </h5>
                    </div>
                    <button
                      className="blue-btn"
                      onClick={() => {
                        setTabState("Portfolio");
                      }}
                    >
                      View Portfolio
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content profilecomplate-common">
        <Container>
          <div className="tabborder service-charges-tabing all-marketplace-wrapper">
            {DeveloperDetailLoading ? (
              <>
                <Row>
                  <Loader type={LoaderType.DeveloperMain} />
                </Row>
              </>
            ) : (
              <>
                {/* <div className="tabing-custom">{TabState}</div> */}
                <div className="mysticketab marketplacesticky devloper-inner-profile-data">
                  <Tabs
                    id="uncontrolled-tab-example"
                    className=" custom-tabing"
                    fill
                    activeKey={TabState}
                    onSelect={(e) => {
                      setTabState(e);
                    }}
                  >
                    <Tab eventKey="Profile" title="Profile">
                      {/* {DeveloperDetailLoading ? (
                  <Loader type={LoaderType.MarketMainLeft} />
                ) : (
                )} */}

                      <Row>
                        <Col xl={9} className="developer-sticky-border-top">
                          <div className=" developersticky">
                            <div className="tabimagedata">
                              <img
                                src={
                                  DeveloperDetail?.companylogo
                                    ? DeveloperDetail?.companylogo
                                    : sqtbg
                                }
                                alt={DeveloperDetail?.companylogo}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = sqtbg;
                                }}
                                className="sqtbg"
                              />
                            </div>
                            <div className="market-dev-content">
                              <h5>{DeveloperDetail?.companyname}</h5>
                              <p>
                                {DeveloperDetail?.aboutsubscriber &&
                                  DeveloperDetail?.aboutsubscriber}
                              </p>

                              <ul className="pl20">
                                <li>
                                  Support Hours:
                                  <span>
                                    {" "}
                                    {DeveloperDetail?.supporthours
                                      ? DeveloperDetail?.supporthours
                                      : "-"}
                                  </span>
                                </li>
                                <li>
                                  Response Time:
                                  <span>
                                    {" "}
                                    Guaranteed within 1-2 business days
                                  </span>
                                </li>
                                <li>
                                  Connect with us via{" "}
                                  <a
                                    href={`mailto:${DeveloperDetail?.supportemail}`}
                                    className="theme-color-text fw600"
                                    title={DeveloperDetail?.supportemail}
                                  >
                                    {DeveloperDetail?.supportemail}
                                  </a>
                                  {/* <Link to="/" className="theme-color-text fw600">
                              {DeveloperDetail?.supportemail
                                ? DeveloperDetail?.supportemail
                                : "-"}
                            </Link> */}
                                </li>
                              </ul>
                              <p>
                                Best Regards,
                                <span className="d-block">
                                  {DeveloperDetail?.companyname
                                    ? DeveloperDetail?.companyname
                                    : DeveloperDetail?.subscribername}
                                </span>
                              </p>
                            </div>
                            <div className="online-contact-sec">
                              <div className="single-online-contact-sec">
                                <img src={documentation} alt="documentation" />
                                <div>
                                  <p>Get Started Easily with Online</p>
                                  <h3>Documentation</h3>
                                </div>
                              </div>
                              <div className="single-online-contact-sec">
                                <img src={caller} alt="caller" />
                                <div>
                                  <p>Need Support/Have any Query?</p>
                                  <h3>Create Ticket</h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={3}>
                          <div className="developersticky-inner developer-sticky-sidebar">
                            <div className="developersticky">
                              <div className="information-main">
                                <h2>Information</h2>
                                <div className="all-informations-main">
                                  <div className="single-informations-main">
                                    {/* <div className="status-active gap-2">
                                  <img src={activestatus} alt="activestatus" />
                                  <span className="green-color-text">
                                    {DeveloperDetail?.workstatus
                                      ? DeveloperDetail?.workstatus
                                      : "-"}
                                  </span>
                                </div> */}
                                    <div className="status-active gap-2">
                                      {DeveloperDetail?.workstatus ? (
                                        <>
                                          {/* Green Status */}
                                          <img
                                            src={activestatus}
                                            alt="active status"
                                          />
                                          <span className="green-color-text">
                                            {DeveloperDetail.workstatus}
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <img
                                            src={blackDot}
                                            alt="active status"
                                          />
                                          <span className="no-status-text">
                                            Status Not Available
                                          </span>
                                        </>
                                      )}
                                    </div>
                                  </div>

                                  <div className="singleinfo-socialmedia">
                                    {(DeveloperDetail?.facebooklink ||
                                      DeveloperDetail?.instagramlink ||
                                      DeveloperDetail?.twitterlink ||
                                      DeveloperDetail?.linkedinlink ||
                                      DeveloperDetail?.blogslink) && (
                                      <div className="single-informations-main">
                                        <h5>Social Profiles</h5>
                                        <div className="d-flex align-items-center gap-2">
                                          {DeveloperDetail?.facebooklink && (
                                            <a
                                              target="_blank"
                                              rel="noreferrer"
                                              href={
                                                DeveloperDetail?.facebooklink
                                              }
                                              className="mb-0"
                                            >
                                              <img
                                                src={fb}
                                                alt="Facebook"
                                                title="Facebook"
                                              />
                                            </a>
                                          )}
                                          {DeveloperDetail?.linkedinlink && (
                                            <a
                                              target="_blank"
                                              rel="noreferrer"
                                              className="mb-0"
                                              href={
                                                DeveloperDetail?.linkedinlink
                                              }
                                            >
                                              <img
                                                src={linkedin}
                                                alt="Linkedin"
                                                title="Linkedin"
                                              />
                                            </a>
                                          )}
                                          {DeveloperDetail?.twitterlink && (
                                            <a
                                              target="_blank"
                                              className="mb-0"
                                              rel="noreferrer"
                                              href={
                                                DeveloperDetail?.twitterlink
                                              }
                                            >
                                              <img
                                                src={twitter}
                                                alt="Twitter"
                                                title="Twitter"
                                              />
                                            </a>
                                          )}
                                          {DeveloperDetail?.instagramlink && (
                                            <a
                                              target="_blank"
                                              rel="noreferrer"
                                              className="mb-0"
                                              href={
                                                DeveloperDetail?.instagramlink
                                              }
                                            >
                                              <img
                                                src={instagram}
                                                alt="Instagram"
                                                title="Instagram"
                                              />
                                            </a>
                                          )}
                                          {DeveloperDetail?.blogslink && (
                                            <a
                                              target="_blank"
                                              rel="noreferrer"
                                              className="mb-0"
                                              href={DeveloperDetail?.blogslink}
                                            >
                                              <img
                                                src={blog}
                                                alt="Blogs"
                                                title="Blogs"
                                              />
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className="single-informations-main">
                                      <h5>Support</h5>
                                      {DeveloperDetail?.supportemail ? (
                                        <a
                                          // href="instagram.com"
                                          href={`mailto:${DeveloperDetail?.supportemail}`}
                                          title={DeveloperDetail?.supportemail}
                                          className="theme-color-text"
                                        >
                                          {DeveloperDetail?.supportemail
                                            ? DeveloperDetail?.supportemail
                                            : "-"}
                                        </a>
                                      ) : (
                                        // <Link
                                        //   to={DeveloperDetail?.supportemail}
                                        //   className="theme-color-text"
                                        // >
                                        //   {DeveloperDetail?.supportemail}
                                        // </Link>
                                        "-"
                                      )}
                                      {/* <Link to="/" className="theme-color-text">
                                https://support.quantumdatalytica.com/                                
                              </Link> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab>
                    <Tab eventKey="Portfolio" title="Portfolio">
                      <div className="portfolio-main-content">
                        <div className="all-market-place-main all-market-place-main-developer">
                          {MachineList?.length > 0 &&
                            MachineList?.map((item_m, index_m) => (
                              <>
                                <div
                                  key={index_m}
                                  className="single-market-place-main new-single-market-place-main cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    fnMachineDetail(item_m?.machineid);
                                  }}
                                >
                                  <div className="single-market-place-img">
                                    <img
                                      src={
                                        item_m?.machinelogo !== "" &&
                                        item_m?.machinelogo !== null
                                          ? item_m?.machinelogo
                                          : DemoLogo
                                      }
                                      alt={item_m?.machinename}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = DemoLogo;
                                      }}
                                    />
                                  </div>
                                  <div className="machine-card-right-content">
                                    <h4 title={item_m?.machinename}>
                                      {commonservices.truncateText(
                                        item_m?.machinename,
                                        CountCharacter.MachineName,
                                      )}
                                    </h4>
                                    <div className="rating-user-box">
                                      <span className="blue-badge">
                                        {item_m?.ratingcount || 0} user
                                      </span>
                                      {item_m?.avgrating > 0 ? (
                                        <div className="market-place-content-ratings">
                                          {renderRatingStars(item_m?.avgrating)}
                                          <span>
                                            {item_m?.avgrating?.toFixed(1)}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="market-place-content-ratings">
                                          {renderRatingStars(0)}
                                          <span>{0}</span>
                                        </div>
                                      )}
                                      <div className="text-end report-price-single-container sales-data-incard">
                                        <div className="d-flex align-items-center gap-1">
                                          <img src={sales} alt="sales" />
                                          <h6>
                                            {item_m?.salescount
                                              ? item_m?.salescount
                                              : 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                    <p
                                      className="description-text-limited"
                                      title={commonservices.truncateText(
                                        commonservices.stripHTML(
                                          item_m?.shortdescription,
                                        ),
                                        CountCharacter?.MachineShortDetail,
                                      )}
                                    >
                                      {item_m?.shortdescription
                                        ? commonservices.stripHTML(
                                            item_m.shortdescription,
                                          )
                                        : ""}
                                    </p>
                                    <div className="developer-box">
                                      <img
                                        src={profileicon}
                                        alt="profileicon"
                                      />
                                      <Link>{item_m?.subscribername}</Link>
                                    </div>
                                  </div>
                                </div>
                                {/* {loading && (
                                <Loader type={LoaderType.MachineCardLoader} count={6} />
                              )} */}
                              </>
                            ))}
                          {/* {MachineList?.length > 0 &&
                            MachineList?.map((item_m, index_m) => (
                              <>
                                <div
                                  key={index_m}
                                  className="single-market-place-main cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    fnMachineDetail(item_m?.machineid);
                                  }}
                                >
                                  <div className=" d-flex align-items-center justify-content-between sehedular-card-inner-size">
                                    <div className="d-flex gap-2 align-items-center">
                                      <div className="single-market-place-img">
                                        <img
                                          src={
                                            item_m?.machinelogo !== "" &&
                                            item_m?.machinelogo !== null
                                              ? item_m?.machinelogo
                                              : DemoLogo
                                          }
                                          alt={item_m?.machinename}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = DemoLogo;
                                          }}
                                        />
                                      </div>
                                      <div className="market-place-content-title mb-0">
                                        <h4 title={item_m?.machinename}>
                                          {commonservices.truncateText(
                                            item_m?.machinename,
                                            CountCharacter.MachineName,
                                          )}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="text-end report-price-single-container ">
                                      <h3 className="report-price-single">
                                        {item_m?.price > 0
                                          ? `$ ${(item_m?.price).toFixed(2)}`
                                          : "FREE"}
                                      </h3>
                                    </div>
                                  </div>
                                  <div className="market-place-content">
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                      <span className="blue-badge">
                                        {item_m?.categoryname}
                                      </span>
                                      <div className="d-flex gap-2 ms-auto">
                                        <div className="market-place-content-ratings">
                                          <img src={stars} alt="stars" />
                                          <span>
                                            {item_m?.avgrating
                                              ? item_m?.avgrating.toFixed(1)
                                              : 0}
                                          </span>
                                        </div>
                                        <div className="text-end report-price-single-container sales-data-incard">
                                          <div className="d-flex align-items-center gap-1">
                                            <img src={sales} alt="sales" />
                                            <h6>
                                              {item_m?.salescount
                                                ? item_m?.salescount
                                                : 0}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <p
                                      title={item_m.shortdescription}
                                      dangerouslySetInnerHTML={{
                                        __html: item_m?.shortdescription
                                          ? item_m.shortdescription
                                          : "",
                                      }}
                                    />
                                    <div className="d-flex align-items-end justify-content-between">
                                      <div className="developer-name">
                                        <span className="developer">
                                          Developer
                                        </span>
                                        <div className="developer-detail">
                                          {item_m?.subscribername}
                                        </div>
                                      </div>
                                      <span className="crossarrow ms-auto">
                                        <img
                                          src={crossarrow}
                                          alt="crossarrow"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))} */}
                        </div>
                        {MachineList?.length == 0 && <Nodata />}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
}

export default MarketPlaceDeveloper;
